
define('jst!lib/_dynamic_content_overlay',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="body">\n\n</div>');
 });

